/*

----- Quantity selectors functionality ----- 
- Free Text 
- Dropdown
- Case quantity input checker.
- Stock on hand checker ( using the max value ).
- Validation for this uses the same validation mechanism that is used throughout express ( Abide )
*/

// Initialise all selectors on the page ( normally run on page load )
function initialiseAll() {
  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1,"Quantity Selectors: Attempting to initialise ALL selectors on the page.");
  }
  $(expressSelectors()['quantity-selector']['initialise']).each(function() {
    // Store context.
    let context = $(this);
    // Initialise.
    let init = initialise(context);
  });
}

// Just initialise the selector that is in context ( i.e after ajax )
function initialise(context) {
  if (!context) {
    return false;
  }
  let id = context.attr('quantity-selector');
  if (!id) {
    context.attr('quantity-selector', generateId());
  } else {
    AXISDebug.output(1,"Quantity Selectors: Skipping initalisation as selector is already initialised.", context);
    return false;
  }
  // Find out whether this is a dropdown or free text.
  let isDropdown = context.is('select');
  // Put container into context.
  let container = (isDropdown ? context.parents('.quantity-selector-container') : context.parents('.quantity-free-text-container'));
  // Find submit button.
  let basketAddButton = context.parents('form').find(expressSelectors()['basket']['add-trigger']);
  // Make sure container exists otherwise it is most likely the markup is completely wrong.
  if (container.length == 0) {
    AXISDebug.output(3,"Quantity Selectors: Failed to initialise selector due to no container being found.",context);
    return false;
  }
  // Check if buttons exist if this is a free text input.
  if (!isDropdown) {
    // Increment button.
    let incrementButton = container.find(expressSelectors()['quantity-selector']['incrementor']);
    if (incrementButton.length == 0) {
      AXISDebug.output(3,"Quantity Selectors: No increment button found.",context);
      return false;
    }
    // Add attribute to increment button.
    incrementButton.attr('data-increment-button','');
    // Deincrement button.
    let deincrementButton = container.find(expressSelectors()['quantity-selector']['deincrementor']);
    if (deincrementButton.length == 0) {
      AXISDebug.output(3,"Quantity Selector: No deincremenent button found.",context);
      return false;
    }
    // Add attribute to deincrement button.
    deincrementButton.attr('data-deincrement-button','');
    // Input value.
    let value = parseInt(context.val());
    // Fallback.
    if (value == NaN) {
      value = 0;
      // Update selector.
      context.val(value);
    }
    // Get min 
    let min = parseInt(context.attr('min'));
    // Get max
    let max = parseInt(context.attr('max'));
    // Get step ( want to multiple the value by ).
    let step = parseInt(context.attr('step'));
    // Fallback.
    if (!step) {
      step = 1;
    }
    // If min is defined and if the next step is less than the min then disable the de-increment button.
    if ((min) && !(calculateStep(value, step, false) >= min)) {
      deincrementButton.addClass('disabled');
    }
    // If a max is defined and if the next step is more than the max then disable increment button.
    if ((max) && !(calculateStep(value, step, true) <= max)) {
      incrementButton.addClass('disabled');
    }
    // Wether to disable incrementor due to max being hit.
    let disableIncrementor = false;
    // Wether to disable deincrementor due to min being hit.
    let disableDeincrementor = false;
    // If input is disabled / readonly then disable buttonss.
    if (context.attr('readonly') || context.attr('disabled') || context.attr('.disabled')) {
      incrementButton.addClass('disabled');
      deincrementButton.addClass('disabled');
    }
    // Add click listener for incrementor button.
    incrementButton.add(deincrementButton).on('click', function(event) {
      // Prevent default behavour.
      event.preventDefault();
      // Grab context.
      let button = $(this);
      // Check if button is disabled.
      let isDisabled = button.hasClass('disabled');
      if (isDisabled) {
        // Check if an error message is actually defined.
        let errorMessage = $('[' + expressSelectors()['forms']['validation']['external-error'] + '=' + context.attr('id') + ']');
        if (errorMessage) {
          // Get the actual message.
          errorMessage = errorMessage.html();
          if (errorMessage) {
            callouts.create(errorMessage, 2, "side");
          }
        }
      }
      
      // If either the button or input is disabled then exit.
      if (isDisabled) {
        return false;
      }
      // Find out whether this is a incrementor or deincrementor.
      let isIncrementor = (button.attr('data-increment-button') != undefined);
      if (!isIncrementor) {
        // Check if value is already 0.
        if (value == 0) { 
          return false;
        }
      }
      // Get Value.
      value = parseInt(context.val());
      // Calculate step.
      value = calculateStep(value, step, isIncrementor);
      // Add value to element to validated.
      context.val(value);
      // Trigger change for anything that is listening to the input ( sliders ).
      context.trigger('change');
    });

    // When the input has been changed.
    context.on('change', function(event) {
      // Grab context.
      let input = $(this);
      // Get value.
      value = parseInt(input.val());
      // Get max
      max = parseInt(input.attr('max'));
      // get min.
      min = parseInt(input.attr('min'));
      // Fallback.
      if (!min) {
        min = 0;
      }
      // Check to see whether you can increment again.
      if (max) {
        let disable = disableIncrementorButton(value, max, step);
        // Disable is max is exceeded.
        if (disable) {
          incrementButton.addClass('disabled');
        } else {
          incrementButton.removeClass('disabled');
        }
      }
      // Check to see whether you can deincrement again.
      if (min != undefined && min != NaN) {
        let disabled = disableDeincrementorButton(value, min, step);
        // Disable is min is exceeded.
        if (disabled) {
          deincrementButton.addClass('disabled');
          // Disable add to basket button.
          if (value < min || value < step) {
            basketAddButton.addClass('disabled');
          }
        } else {
          deincrementButton.removeClass('disabled');
        }
        if (value >= min) {
          basketAddButton.removeClass('disabled');
        }
      }
    });
  }
}

function disableIncrementorButton(value, max, step) {
  return ((max) && ((value >= max) || !(calculateStep(value, step, true) <= max)));
}

function disableDeincrementorButton(value, min, step) {
  return ((value <= min) || !(calculateStep(value, step, false) >= min));
}

// Calculate the quantity selector's value.
function calculateStep(value, step, increment = true) {
  // Incrementor logic
  if (increment) {
    // If no step defined.
    if (!step) {
      // Just increment.
      value++;
    } else {
      // If not a multiple then correct it.
      if (!multipleOf(value, step)) {
        // Round up to the nearest multiple.
        value = roundUp(value, step);
      } else {
        // Add current value + step together if no errors.
        value = (value + step);
      }
    }
  } else {
    // Deincrementor logic.
    // If no step defined.
    if (!step) {
      // Just increment.
      value--;
    } else {
      // If not a multiple then correct it.
      if (!multipleOf(value, step)) {
        // Round down to the nearest multiple.
        value = roundDown(value, step);
      } else {
        // Add current value + step together if no errors.
        value = (value - step);
      }
    }
  }
  return value;
}

var AXISQuantitySelectors = $.AXISQuantitySelectors = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    }
}

export { AXISQuantitySelectors };

